import { useMemo } from "react";

const useStyle = () => {
  const classes = useMemo(() => {
    return {
      // Body row: big percentage cards on the left, value cards grid filling the rest.
      // Fills the remaining height of the fixed-height panel.
      mainContainer: {
        display: "flex",
        flexDirection: "row" as "row",
        justifyContent: "flex-start",
        alignItems: "stretch",
        width: "100%",
        flex: "1 1 0",
        minHeight: 0,
        gap: 8,
        paddingTop: "5px",
      },
      // Left column: the big percentage cards, stacked to fill the panel height.
      firstDiv: {
        display: "flex",
        flexDirection: "column" as "column",
        flex: "0 0 200px",
        gap: 8,
        paddingTop: "5px",
      },
      // Value cards: stacked top-to-bottom, overflowing into extra columns and
      // stretching to use the full available width and height.
      secondDiv: {
        display: "grid",
        gridAutoFlow: "column" as "column",
        gridAutoColumns: "minmax(0, 1fr)",
        height: "100%",
        minHeight: 0,
        flex: "1 1 0",
        gap: 8,
        paddingTop: "5px",
      },
      firstCard: {
        display: "flex",
        width: "100%",
        flex: "1 1 0",
        minHeight: 0,
        alignItems: "center",
      },
      secondCard: {
        display: "flex",
        width: "100%",
        height: "100%",
        alignItems: "center",
      },
    };
  }, []);
  return {
    classes,
  };
};
export { useStyle };
